import { render } from "./HomeEntryScene.vue?vue&type=template&id=3127fd79&scoped=true"
import script from "./HomeEntryScene.vue?vue&type=script&lang=js"
export * from "./HomeEntryScene.vue?vue&type=script&lang=js"

import "./HomeEntryScene.vue?vue&type=style&index=0&id=3127fd79&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3127fd79"]])

export default __exports__